import { render, staticRenderFns } from "./DistanceText.vue?vue&type=template&id=17fac9a6&scoped=true&"
import script from "./DistanceText.vue?vue&type=script&lang=js&"
export * from "./DistanceText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fac9a6",
  null
  
)

export default component.exports